import Log from "@workspace/nextjs_utils/src/Log";

const runSafely = (call: OptimoveCall, api: OptimoveApi) => {
  try {
    const result = call(api);
    if (result) {
      return Promise.resolve(result).catch((error) => {
        Log.warn("Optimove SDK call rejected, ignoring", { error });
      });
    }
  } catch (error) {
    Log.warn("Optimove SDK call threw, ignoring", { error });
  }
  return undefined;
};

export default runSafely;
